'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var state = {
  // Non-mutable after initial set
  lenses: [],
  nonPrescriptionLens: {},
  prescriptions: [],
  frame: {
    selectedVariant: {}
  },
  cms: {},

  // mutable
  activeLenses: [],
  finalLens: {},
  finalVariant: {},
  activePrescription: {
    id: '',
    prescriptionSet: false,
    newPrescription: true,
    date: '',
    store: '',
    type: '',
    left: { sph: '', cyl: '', axis: '', add: '', ipd: '', ph: '' },
    right: { sph: '', cyl: '', axis: '', add: '', ipd: '', ph: '' }
  },
  options: {
    step1: {
      name: 'Vision:',
      cost: 0
    },
    step2: {
      name: 'Lens Type:',
      cost: 0
    },
    step3: {
      name: 'Lens Option:',
      cost: 0
    }
  },
  meta: {},
  showPrescriptionModule: false,
  step: 1,
  totalPrice: 0
};

exports.default = state;